module.exports = __webpack_public_path__ + "static/media/eicr.481787c1.png";